import { render, staticRenderFns } from "./kuzov.vue?vue&type=template&id=54e08ec8&scoped=true&"
import script from "./kuzov.vue?vue&type=script&lang=js&"
export * from "./kuzov.vue?vue&type=script&lang=js&"
import style0 from "./kuzov.vue?vue&type=style&index=0&id=54e08ec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e08ec8",
  null
  
)

export default component.exports